<div style="text-align:center; margin-top:20px;" [hidden]="!shown"
    *ngIf=" angularMatData && angularMatData.data.length == 0">
    <span translate>No upcoming/missing assignments exist for this student</span>
</div>
<div [hidden]="!shown" *ngIf="angularMatData && angularMatData.data.length > 0"
    style="overflow:auto;flex-grow:1;min-width: 1220px;">
    <mat-table #table [dataSource]="angularMatData" multiTemplateDataRows matSortDisableClear matSort
        id="studentUpcomingMissingAssignmentDataTable" matSortActive="DueDate" matSortDirection="asc"
        aria-label="Student Upcoming/Missing Table" tabindex="0">
        <ng-container matColumnDef="More">]
            <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;" translate>More
            </mat-header-cell>
            <mat-cell *matCellDef="let SA" style="min-width:68px;max-width:68px;text-align:center;">
                <span *ngIf="showToggleIcon(SA)"
                    [ngClass]="checkExpanded(SA) ? 'detail-row-expanded-icon': 'detail-row-collapsed-icon'"
                    class="material-icons" aria-label="Expand row for more details"></span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Course">]
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                <span translate>Course Name</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="Course" dataType="string"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let SA">{{SA.Course}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Term">]
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:150px;">
                <span>Term</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="Term" dataType="string"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let SA" style="min-width:100px;max-width:150px;">
                <span>{{SA.OverrideGradingTerm != null?
                    SA.OverrideGradingTerm:SA.Term}}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="DueDateDay">]
            <mat-header-cell *matHeaderCellDef style="min-width:80px; max-width:80px;">
            </mat-header-cell>
            <mat-cell *matCellDef="let SA" style="min-width:80px; max-width:80px;"
                [ngClass]="utilityClass.getAssignmentStatusClass(SA.AssignmentStatus)">
                <div style="width:100%; text-align:right; padding-right:5px;">
                    <span>{{getAssignmentStatus(SA.AssignmentStatus, SA.DueDate)}}</span>
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="DueDate">]
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 110px; max-width: 110px; ">
                <span translate>Due</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="DueDate" dataType="date"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let SA" style="min-width:110px; max-width:110px; text-align:left;"
                [ngClass]="utilityClass.getAssignmentStatusClass(SA.AssignmentStatus)">
                <span *ngIf="SA.DueDate != '0001-01-01T00:00:00'">{{SA.DueDate | date:'MM/dd/yy'}}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="AssignedDateDay">]
            <mat-header-cell *matHeaderCellDef style="display: none"></mat-header-cell>
            <mat-cell *matCellDef="let SA" style="min-width: 30px; max-width: 30px;">
                <span *ngIf="SA.AssignedDate != '0001-01-01T00:00:00'">{{SA.AssignedDate | date:'E'}}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="AssignedDate">]
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                <span translate>Assigned</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="AssignedDate" dataType="date"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let SA">
                <span *ngIf="SA.AssignedDate != '0001-01-01T00:00:00'">{{SA.AssignedDate | date:'MM/dd/yy'}}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Assignment">]
            <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Assignment</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="Assignment" dataType="string"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let SA">
                <div style="width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden">{{SA.Assignment}}
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="GradeBookUnit">]
            <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Unit</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="GradeBookUnit" dataType="string">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let SA">
                <div style="width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden">{{SA.GradeBookUnit}}
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Category">]
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;max-width:150px;" translate>
                <span *ngIf="loginSettings.ParentPortalAssignmentsShowEffectiveScore" translate>Category-ID</span>
                <span *ngIf="!loginSettings.ParentPortalAssignmentsShowEffectiveScore" translate>Category</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="Category" dataType="string"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let SA" style="min-width:150px;max-width:150px;">
                {{SA.Category}}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Possible">]
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:70px;max-width:120px;"
                class='number-header'><span translate>Points Possible</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="Possible" dataType="number">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let SA" style="min-width:70px;max-width:120px;" class='number-cell-filter'>
                <span *ngIf="SA.Possible != -1 && SA.Possible != 0">{{SA.Possible}}</span>
            </mat-cell>
        </ng-container>
        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let SA" [attr.colspan]="columnsToDisplay.length" style="width:100%;"
                class="mat-detail-card">
                <div *ngIf="angularMatData.checkVisible(SA)">
                    <table style="width:100%;" aria-label="Student Assignment Details Table" tabindex="-1">
                        <tr>
                            <td *ngIf="canSendEmail" class="detail-card-data" style="width: 120px;">
                                <a class="link" (click)="sendEmail(SA.TeacherName, SA.TeacherEmail)" translate>Email
                                    Teacher</a>
                            </td>
                            <td class="detail-card-data" style="width: 120px;">
                                <a *ngIf="showClassProfile(SA)" (click)="classInformationClick(SA)" class="link"
                                    translate>Class Information</a>
                            </td>
                            <td class="detail-card-data" style="width: 120px;">
                                <a *ngIf="showTeacherProfile(SA)" (click)="teacherProfileClick(SA)" class="link"
                                    translate>Teacher Profile</a>
                            </td>
                        </tr>
                        <tr *ngIf="utilityClass.IsValid(SA.Comment)">
                            <td colspan="2" class="detail-card-heading" translate>Comments</td>
                        </tr>
                        <tr *ngIf="utilityClass.IsValid(SA.Comment)">
                            <td colspan="2">
                                <tyl-quill-text-only class="detail-card-data" [padding]="0" [html]="SA.Comment">
                                </tyl-quill-text-only>
                            </td>
                        </tr>
                        <tr *ngIf="utilityClass.IsValid(SA.Summary)">
                            <td colspan="2" class="detail-card-heading" translate>Summary</td>
                        </tr>
                        <tr *ngIf="utilityClass.IsValid(SA.Summary)">
                            <td class="detail-card-data" colspan="2">{{SA.Summary}}</td>
                        </tr>
                        <tr *ngIf="SA.AttachmentDetail != null && SA.AttachmentDetail.length > 0">
                            <td colspan="2" class="detail-card-heading" translate>Details</td>
                        </tr>
                        <tr *ngIf="SA.AttachmentDetail != null && SA.AttachmentDetail.length > 0">
                            <td colspan="2">
                                <tyl-quill-text-only class="detail-card-data" [padding]="0"
                                    [html]="SA.AttachmentDetail"></tyl-quill-text-only>
                            </td>
                        </tr>
                        <tr *ngIf="SA.GradeBookObjectives?.length > 0">
                            <td colspan="2">
                                <div>
                                    <table style="width:50%;">
                                        <thead>
                                            <tr class="detail-card-heading">
                                                <th style="display: none;">ID</th>
                                                <th style="min-width: 100px;" translate>Standards</th>
                                                <th style="min-width: 100px;" translate>Score</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="min-height:40px;" class="detail-card-data"
                                                *ngFor="let GO of SA.GradeBookObjectives">
                                                <td style="display: none;"></td>
                                                <td ng-class="utilityClass.objectiveLevelClass(GO.Level)"
                                                    style="line-height:1.5em;">{{GO.Standard}}</td>
                                                <td style="line-height:normal;">
                                                    <div *ngFor=" let SBS of GO.StandardsBasedScores">
                                                        {{ getSBSScore(SBS)}}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="isAttachmentExists(SA.AssignmentId)">
                            <td colspan="2" class="detail-card-heading" translate>Attachments</td>
                        </tr>
                        <tr *ngFor="let attachment of getStudentAttachmentByAssignmentId(SA.AssignmentId)"
                            style="line-height:1.5em;" class="detail-card-data">
                            <td style="width:30%">
                                <a class="link" (click)="utilityClass.saveFile(attachment)"
                                    translate>{{attachment.DocumentName}}</a>
                            </td>
                            <td style="width:70%">{{attachment.DocumentType}}</td>
                        </tr>
                    </table>
                </div>
            </td>
        </ng-container>
        <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" id="SAdataHeader"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="SAdataRow{{i}}" tabindex="0"
            [attr.aria-label]="getAriaRow(row)" [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
            style="padding:0;overflow: hidden;" matRipple (click)="toggleExpanded(row)"
            (keydown)="rowKeyPress($event, row)">
        </mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']"
            [@detailExpand]="checkExpanded(row) && showToggleIcon(row) ? 'expanded' : 'collapsed'"
            (@detailExpand.start)="$event.toState == 'expanded' ? angularMatData.setVisible(row, true) : null"
            (@detailExpand.done)="$event.toState == 'collapsed' ? angularMatData.setVisible(row, false) : null"
            style="overflow: hidden" class="mat-detail-row">
        </mat-row>
    </mat-table>
</div>